var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLargeLogoCtct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 241.53 116.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fbbc04;}.e{fill:#4285f4;}.f{fill:#ea4335;}.g{fill:#0f9d58;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M57.5,58.66l39.22-22.65c9.23-5.33,12.39-17.13,7.06-26.36C98.46,.42,86.66-2.74,77.43,2.59L9.65,41.72l47.85,16.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M87.06,116.86c6.67,0,13.16-3.46,16.73-9.65,5.33-9.23,2.17-21.03-7.06-26.36L28.95,41.72c-9.23-5.33-21.03-2.17-26.36,7.06-5.33,9.23-2.17,21.03,7.06,26.36l67.77,39.13c3.04,1.75,6.36,2.59,9.63,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M154.48,116.86c3.27,0,6.59-.83,9.63-2.59l67.77-39.13-47.24-17.29-39.83,23c-9.23,5.33-12.39,17.13-7.06,26.36,3.57,6.19,10.06,9.65,16.73,9.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M222.21,77.73c6.67,0,13.16-3.46,16.73-9.65,5.33-9.23,2.17-21.03-7.06-26.36L164.11,2.59c-9.23-5.33-21.03-2.17-26.36,7.06-5.33,9.23-2.17,21.03,7.06,26.36l67.77,39.13c3.04,1.75,6.36,2.59,9.63,2.59Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeLogoCtct);
export default __webpack_public_path__ + "static/media/LargeLogoCTCT.002da63235b142c4958f1694e0c525c4.svg";
export { ForwardRef as ReactComponent };